module.exports = __webpack_public_path__ + "img/contract_bg5.1215659e.png";